// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import VerticalCard from "../components/VerticalCard";
// import SummaryApi from "../common";
// import { motion } from "framer-motion";
// import { FaFilter } from "react-icons/fa";

// const CategoryProduct = () => {

//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [showFilter, setShowFilter] = useState(false);

//   const navigate = useNavigate();
//   const location = useLocation();

//   const query = new URLSearchParams(location.search);

//   const [filters, setFilters] = useState({
//     category: query.get("category") || "",
//     brand: query.get("brand") || "",
//     ram: query.get("ram") || "",
//     processor: query.get("processor") || "",
//   });

//   const [sortBy, setSortBy] = useState("");

//   // ✅ PRICE FUNCTION (IMPORTANT)
//   const getPrice = (item) => {
//     return Number(item?.variants?.[0]?.price || 0);
//   };

//   const fetchData = async () => {
//     setLoading(true);

//     try {
//       const res = await fetch(SummaryApi.filterProduct.url, {
//         method: SummaryApi.filterProduct.method,
//         credentials:"include",
//         headers: { "content-type": "application/json" },
//         body: JSON.stringify(filters),
//       });

//       const dataRes = await res.json();
//       setData(dataRes?.data || []);
//     } catch (err) {
//       console.error(err);
//     }

//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchData();
//   }, [filters]);

//   const handleFilterChange = (key, value) => {
//     const newFilters = {
//       ...filters,
//       [key]: filters[key] === value ? "" : value,
//     };

//     setFilters(newFilters);

//     const params = new URLSearchParams(newFilters);
//     navigate(`/product-category?${params.toString()}`);
//   };

//   const clearFilters = () => {
//     setFilters({
//       category: "",
//       brand: "",
//       ram: "",
//       processor: "",
//     });
//     navigate("/product-category");
//   };

//   // ✅ SORT FIXED
//   const handleSort = (value) => {
//     setSortBy(value);

//     let sorted = [...data];

//     if (value === "asc") {
//       sorted.sort((a, b) => getPrice(a) - getPrice(b));
//     } else if (value === "dsc") {
//       sorted.sort((a, b) => getPrice(b) - getPrice(a));
//     }

//     setData(sorted);
//   };

//   const brands = ["apple", "dell", "hp", "lenovo", "asus"];
//   const rams = ["4gb", "8gb", "16gb", "32gb"];
//   const processors = ["i3", "i5", "i7", "ryzen5", "ryzen7"];

//   return (
//     <div className="bg-gray-50 min-h-screen">

//       <div className="container mx-auto px-4 py-6">

//         <div className="flex justify-between items-center mb-6">
//           <h2 className="text-2xl font-bold">
//             Products ({data.length})
//           </h2>

//           <div className="flex gap-3">
//             <select
//               value={sortBy}
//               onChange={(e) => handleSort(e.target.value)}
//               className="border px-3 py-2 rounded-lg text-sm"
//             >
//               <option value="">Sort</option>
//               <option value="asc">Low → High</option>
//               <option value="dsc">High → Low</option>
//             </select>

//             <button
//               onClick={() => setShowFilter(true)}
//               className="lg:hidden bg-black text-white px-4 py-2 rounded-lg flex gap-2 items-center"
//             >
//               <FaFilter /> Filter
//             </button>
//           </div>
//         </div>

//         <div className="grid lg:grid-cols-[260px,1fr] gap-6">

//           {/* FILTER */}
//           <motion.div
//             initial={{ x: -300 }}
//             animate={{ x: showFilter || window.innerWidth >= 1024 ? 0 : -300 }}
//             className="fixed lg:sticky top-0 left-0 w-[260px] h-full bg-white/70 backdrop-blur-2xl border-r shadow-xl p-5 rounded-r-2xl z-50"
//           >
//             <div className="flex justify-between mb-4">
//               <h3 className="font-bold text-lg">Filters</h3>
//               <button onClick={() => setShowFilter(false)} className="lg:hidden">✕</button>
//             </div>

//             <button
//               onClick={clearFilters}
//               className="text-red-500 text-sm mb-4 underline"
//             >
//               Clear All
//             </button>

//             {[{ title: "Brand", key: "brand", data: brands },
//               { title: "RAM", key: "ram", data: rams },
//               { title: "Processor", key: "processor", data: processors }
//             ].map((section) => (

//               <div key={section.key} className="mb-6">

//                 <h3 className="font-semibold mb-3">{section.title}</h3>

//                 <div className="flex flex-wrap gap-2">
//                   {section.data.map((item) => (
//                     <button
//                       key={item}
//                       onClick={() => handleFilterChange(section.key, item)}
//                       className={`px-3 py-1 rounded-full text-sm border transition
//                       ${
//                         filters[section.key] === item
//                           ? "bg-black text-white scale-105"
//                           : "hover:bg-gray-200"
//                       }`}
//                     >
//                       {item}
//                     </button>
//                   ))}
//                 </div>

//               </div>

//             ))}
//           </motion.div>

//           {/* PRODUCTS */}
//           <div>

//             {loading ? (
//               <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
//                 {[...Array(8)].map((_, i) => (
//                   <div key={i} className="bg-gray-200 h-60 rounded-xl animate-pulse"></div>
//                 ))}
//               </div>
//             ) : data.length === 0 ? (
//               <div className="text-center py-20 text-gray-500">
//                 😢 No products found
//               </div>
//             ) : (
//               <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">

//                 {data.map((item, i) => (
//                   <motion.div
//                     key={item._id}
//                     initial={{ opacity: 0, y: 40 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ delay: i * 0.05 }}
//                   >
//                     {/* ✅ PRICE PASS */}
//                     <VerticalCard data={[{ ...item, price: getPrice(item) }]} />
//                   </motion.div>
//                 ))}

//               </div>
//             )}

//           </div>

//         </div>

//       </div>

//     </div>
//   );
// };

// export default CategoryProduct;
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import VerticalCard from "../components/VerticalCard";
import SummaryApi from "../common";
import { motion } from "framer-motion";
import { FaFilter } from "react-icons/fa";

const CategoryProduct = () => {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const query = new URLSearchParams(location.search);

  const [filters, setFilters] = useState({
    brand: query.get("brand") || "",
    ram: query.get("ram") || "",
    processor: query.get("processor") || "",
    price: "",
    availability: "",
  });

  const [sortBy, setSortBy] = useState("");

  const getPrice = (item) => Number(item?.variants?.[0]?.price || 0);

  const fetchData = async () => {
    setLoading(true);

    const res = await fetch(SummaryApi.filterProduct.url, {
      method: "POST",
      credentials: "include",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(filters),
    });

    const result = await res.json();
    setData(result?.data || []);
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [filters]);

  const handleFilterChange = (key, value) => {
    const updated = {
      ...filters,
      [key]: filters[key] === value ? "" : value,
    };

    setFilters(updated);
    navigate(`/product-category?${new URLSearchParams(updated)}`);
  };

  const clearFilters = () => {
    setFilters({});
    navigate("/product-category");
  };

  const handleSort = (value) => {
    setSortBy(value);
    let sorted = [...data];

    if (value === "asc") sorted.sort((a, b) => getPrice(a) - getPrice(b));
    if (value === "dsc") sorted.sort((a, b) => getPrice(b) - getPrice(a));

    setData(sorted);
  };

  // 🔥 FILTER DATA
  const brands = ["apple", "dell", "hp", "lenovo", "asus"];
  const rams = ["4gb", "8gb", "16gb", "32gb"];
  const processors = ["i3", "i5", "i7"];
  const priceRanges = ["0-20000", "20000-40000", "40000+"];
  const availability = ["in-stock", "out-stock"];

  return (
    <div className="bg-[#eef1f6] min-h-screen">

      <div className="max-w-7xl mx-auto px-4 py-6">

        {/* 🔥 TOP */}
        <div className="flex justify-between items-center mb-6">

          <h2 className="text-xl md:text-2xl font-bold">
            Products ({data.length})
          </h2>

          <div className="flex gap-3">

            <select
              value={sortBy}
              onChange={(e) => handleSort(e.target.value)}
              className="bg-white px-3 py-2 rounded-xl shadow text-sm"
            >
              <option value="">Sort</option>
              <option value="asc">Low → High</option>
              <option value="dsc">High → Low</option>
            </select>

            <button
              onClick={() => setShowFilter(true)}
              className="lg:hidden bg-black text-white px-4 py-2 rounded-xl flex gap-2 items-center"
            >
              <FaFilter /> Filter
            </button>

          </div>

        </div>

        <div className="grid lg:grid-cols-[260px,1fr] gap-6">

          {/* 🔥 FILTER PANEL */}
          <motion.div
            initial={{ x: -300 }}
            animate={{ x: showFilter || window.innerWidth >= 1024 ? 0 : -300 }}
            className="fixed lg:sticky top-0 left-0 w-[260px] h-full bg-white/60 backdrop-blur-xl border shadow-xl p-5 rounded-r-2xl z-50"
          >

            <div className="flex justify-between mb-4">
              <h3 className="font-bold">Filters</h3>
              <button onClick={() => setShowFilter(false)} className="lg:hidden">✕</button>
            </div>

            <button onClick={clearFilters} className="text-red-500 text-sm mb-4 underline">
              Clear All
            </button>

            {/* 🔥 SECTIONS */}
            {[
              { title: "Brand", key: "brand", data: brands },
              { title: "RAM", key: "ram", data: rams },
              { title: "Processor", key: "processor", data: processors },
              { title: "Price", key: "price", data: priceRanges },
              { title: "Availability", key: "availability", data: availability },
            ].map((section) => (

              <div key={section.key} className="mb-5">

                <h4 className="font-semibold mb-2 text-sm">{section.title}</h4>

                <div className="flex flex-wrap gap-2">

                  {section.data.map((item) => (
                    <button
                      key={item}
                      onClick={() => handleFilterChange(section.key, item)}
                      className={`px-3 py-1 text-xs rounded-full border transition
                      ${
                        filters[section.key] === item
                          ? "bg-black text-white scale-105"
                          : "hover:bg-gray-200"
                      }`}
                    >
                      {item}
                    </button>
                  ))}

                </div>

              </div>

            ))}

          </motion.div>

          {/* 🔥 PRODUCTS */}
          <div>

            {loading ? (
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {[...Array(8)].map((_, i) => (
                  <div key={i} className="bg-gray-200 h-60 rounded-xl animate-pulse"></div>
                ))}
              </div>
            ) : data.length === 0 ? (
              <div className="text-center py-20 text-gray-500">
                No products found 😢
              </div>
            ) : (
              <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">

                {data.map((item, i) => (
                  <motion.div
                    key={item._id}
                    whileHover={{ y: -6 }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                  >
                    <VerticalCard data={[{ ...item, price: getPrice(item) }]} />
                  </motion.div>
                ))}

              </div>
            )}

          </div>

        </div>

      </div>

    </div>
  );
};

export default CategoryProduct;